import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import DataOption from '../../models/DataOption';
import getHoursOffset from '../../../utils/getHoursOffset';

const messages = defineMessages({
  AGENTS: {
    id: 'AGENTS',
    defaultMessage: 'Agents',
  },
});

export default class Agent {
  constructor(intl) {
    if (!intl) {
      throw Error('Missing intl param');
    }

    const hourOffset = getHoursOffset();

    /**
     * Default callqueuereport api params
     * @type {{object: string, action: string, format: string, range_interval: string, value_offset: string}}
     */
    const apiParams = {
      object: 'agent',
      action: 'read',
      format: 'json',
      range_interval: hourOffset,
      value_offset: hourOffset,
      order: 'sub_fullname',
      queue_name: '*',
      unit: 'seconds',
    };

    this.dataOptions = new DataOption({
      type: 'api',
      apiParams,
      adapter: 'agentsStatusToGridAdapter',
      baseColumns: ['Agent'],
      defaultColumns: [],
      hasCategories: false,
      hasColumns: true,
      label: <FormattedMessage {...messages.AGENTS} />,
      labelStr: intl.formatMessage({ ...messages.AGENTS }),
      stat: 'Agent',
      socketEvents: [
        { name: 'agent', adapter: 'agentsStatusSocketToGridAdapter' },
        { name: 'contacts-domain', adapter: 'agentsStatusSocketToGridAdapter' },
      ],
      socketSubscriptions: [
        { type: 'agent' },
        { type: 'contacts' },
      ],
      supportedCharts: ['ResponsiveGridTable'],
      supportedColumns: [],
    });
  }
}
